import React from "react";
import { graphql, Link } from "gatsby";
import { Fade } from "react-reveal";
import { useState } from "react";

import * as styles from "./gen4Awards25.module.scss";

const Gen4Awards25 = ({ component: { label } }) => {
  const [showContent1, setShowContent1] = useState(false);
  const [showContent2, setShowContent2] = useState(false);
  const [showContent3, setShowContent3] = useState(false);
  const [showContent4, setShowContent4] = useState(false);

  const toggleContent = (paragraphNumber) => {
    switch (paragraphNumber) {
      case 1:
        setShowContent1(!showContent1);
        break;
      case 2:
        setShowContent2(!showContent2);
        break;
      case 3:
        setShowContent3(!showContent3);
        break;
      case 4:
        setShowContent4(!showContent4);
        break;
      // Add more cases as needed for additional paragraphs
      default:
        break;
    }
  };

  return (
    <div id={styles.awards}>
      <section className={styles.awardsContainer}>
        <Fade up delay={500}>
          <h2>Award-Winning Offices</h2>
          <div className={styles.awardRow}>
            <div className={styles.col3}>
              <img
                src="/awards25-office-1.jpg"
                alt="photo of East Sac Dental Team"
              />
            </div>
            <div className={styles.col9}>
              <h2>Office of the Year</h2>
              <h3>East Sac Dental</h3>
              {/* <p style={{ marginBottom: '0px' }}><b>Salina, Kansas</b></p> */}
              <p>
              East Sac Dental exemplifies what it means to be a Gen4 LeGENd “Office of the Year.” This team has consistently demonstrated exceptional teamwork, leadership, and operational excellence, exceeding production and collection goals while delivering an outstanding patient experience that keeps people talking. What truly sets East Sac apart is its culture — a supportive, communicative, and high-performing environment where every team member takes ownership of their role.{" "}
                {!showContent1 && (
                  <button onClick={() => toggleContent(1)}>Read More</button>
                )}
              </p>

              {showContent1 && (
                <div>
                  <p>Under the guidance of Office Manager Tamsin, the office thrives through accountability, collaboration, and a shared commitment to quality care. From the front desk to the clinical team, everyone contributes to an atmosphere of positivity and efficiency, which is reflected in both patient feedback and team morale. East Sac Dental doesn’t just succeed on metrics; they elevate those around them, setting a standard for excellence with heart. Their dedication, adaptability, and energy make them a model office and a deserving recipient of this award.</p>
                </div>
              )}
            </div>
          </div>
        </Fade>

        {/* <Fade up delay={500}>
          <div className={styles.awardRow}>
            <div className={styles.col3}>
              <img
                src="/awards24-office1-1-min.jpg"
                alt="photo of Nelson & Tillmann family dentistry team"
              />
            </div>
            <div className={styles.col9}>
              <h2>Office of the Year - Ascenders</h2>

              <h3>?</h3>
              
              <p>
              ?{" "}
                {!showContent2 && (
                  <button onClick={() => toggleContent(2)}>Read More</button>
                )}
              </p>
              <p>
                {showContent2 && (
                  <div>
                    <p>?</p>
                  </div>
                )}
              </p>
            </div>
          </div>
        </Fade> */}

        {/* <Fade up delay={500}>
          <div className={styles.awardRow}>
            <div className={styles.col3}>
              <img
                src="/location-beaumont-min.jpg"
                alt="photo of beaumont family dentistry office"
              />
            </div>
            <div className={styles.col9}>
              <h2>Office of the Year - Growth</h2>

              <h3>Beaumont Family Dentistry - Leestown</h3>
              <p>
                Beaumont's impressive trajectory in growth and development has
                rightfully earned them the Gen4 LeGEND Award for Office of the
                Year for Growth. This prestigious recognition reflects their
                extraordinary success in expanding their patient base, enhancing
                service offerings, and increasing their overall business
                footprint.{" "}
                {!showContent3 && (
                  <button onClick={() => toggleContent(3)}>Read More</button>
                )}
              </p>
              {showContent3 && (
                <div>
                  <p>
                    The team atBeaumont has exhibited a remarkable ability to
                    not only attract new patients but also retain existing ones
                    by providing exceptional dental care and creating a
                    welcoming, trust-inspiring environment.
                  </p>
                  <p>
                    Their strategic marketing efforts, coupled with a strong
                    focus on community engagement, have played a pivotal role in
                    their growth. Furthermore, the office has embraced
                    innovation, incorporating advanced dental technologies and
                    broadening their range of services to meet diverse patient
                    needs. This approach has not only improved patient outcomes
                    and satisfaction but has also positioned Beaumont as a
                    leader in the dental field. The leadership's vision for
                    growth, supported by the dedicated efforts of their team,
                    has led to notable increases in both revenue and reputation.
                  </p>
                  <p>
                    Their success story is a testament to the power of combining
                    excellent patient care with strategic business acumen,
                    making Beaumont an exemplary recipient of the Office of the
                    Year for Growth award.
                  </p>
                </div>
              )}
            </div>
          </div>
        </Fade> */}

        {/* <Fade up delay={500}>
          <div className={styles.awardRow}>
            <div className={styles.col3}>
              <img
                src="/location-gentling-min.jpg"
                alt="photo of cassity implants"
              />
            </div>

            <div className={styles.col9}>
              <h2>Office of the Year - Ops Excellence</h2>
              <h3 className={styles.doctorName}>Gentling Dental Care</h3>

              <p>
                Gentling's exceptional performance in operational excellence has
                earned it the prestigious Gen4 LeGEND Award for Office of the
                Year. This accolade is a testament to their outstanding
                efficiency, seamless patient care processes, and exemplary
                administrative management.{" "}
                {!showContent4 && (
                  <button onClick={() => toggleContent(4)}>Read More</button>
                )}
              </p>
              <p>
                {showContent4 && (
                  <div>
                    <p>
                      The team at Gentling Dental Care has consistently
                      demonstrated a commitment to optimizing every aspect of
                      their operations, from streamlined appointment scheduling
                      and effective patient communication to advanced technology
                      utilization and meticulous record-keeping.
                    </p>
                    <p>
                      Their focus on operational excellence has not only
                      enhanced the patient experience but also improved the
                      workflow for the staff, creating a harmonious and
                      productive work environment. The leadership at Gentling
                      Dental Care has been instrumental in implementing
                      innovative strategies and best practices that drive
                      efficiency and quality care. Their ability to adapt to
                      changing circumstances, while maintaining high standards
                      of service, sets them apart in the dental industry. The
                      team's collaborative efforts, attention to detail, and
                      dedication to continuous improvement have resulted in
                      remarkable operational success, making Gentling Dental
                      Care a model of excellence in dental office management.
                    </p>
                    <p>
                      Their achievement in maintaining such high operational
                      standards makes them a deserving recipient of the Office
                      of the Year for Operational Excellence award, highlighting
                      their role as a leader in setting benchmarks for the
                      industry.
                    </p>
                  </div>
                )}
              </p>
            </div>
          </div>
        </Fade> */}

        {/* <Fade up delay={500}>
          <div className={styles.awardRow}>
            <div className={styles.col3}>
              <img src="/team-logan-c.jpg" alt="photo of cassity implants" />
            </div>

            <div className={styles.col9}>
              <h2>Pathway to Partnership Doctor of The Year</h2>
              <h3 className={styles.doctorName}>Dr. Logan Clements</h3>
              <h4>Community Shores Dental | Michigan</h4>
              <p>
                Gentling's exceptional performance in operational excellence has
                earned it the prestigious Gen4 LeGEND Award for Office of the
                Year. This accolade is a testament to their outstanding
                efficiency, seamless patient care processes, and exemplary
                administrative management. <a href="#">Read More</a>
              </p>
            </div>
          </div>
        </Fade> */}
      </section>
    </div>
  );
};

export default Gen4Awards25;

export const query = graphql`
  fragment Gen4Awards25 on PagesJson {
    components {
      label
    }
  }
`;
